import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      // Simulate subscription
      setSubscribed(true);
      setTimeout(() => {
        setSubscribed(false);
        setEmail('');
      }, 3000);
    }
  };

  return (
    <>
      <style>{`
        .footer {
          background: var(--gray-50);
          border-top: 1px solid var(--gray-200);
          padding: 6rem 2rem 3rem;
          margin-top: auto;
        }

        .footer-container {
          max-width: 1280px;
          margin: 0 auto;
        }

        .footer-newsletter {
          background: var(--white);
          border-radius: var(--radius-xl);
          padding: 3rem;
          margin-bottom: 4rem;
          text-align: center;
          border: 1px solid var(--gray-200);
        }

        .newsletter-title {
          font-size: 2rem;
          font-weight: 700;
          color: var(--gray-900);
          margin-bottom: 0.5rem;
        }

        .newsletter-subtitle {
          font-size: 1.125rem;
          color: var(--gray-600);
          margin-bottom: 2rem;
        }

        .newsletter-form {
          display: flex;
          gap: 1rem;
          max-width: 500px;
          margin: 0 auto;
        }

        .newsletter-input {
          flex: 1;
          padding: 0.875rem 1.25rem;
          border: 1px solid var(--gray-300);
          border-radius: var(--radius);
          font-size: 1rem;
          background: var(--white);
          color: var(--gray-900);
          transition: all var(--transition-fast);
        }

        .newsletter-input:hover {
          border-color: var(--gray-400);
        }

        .newsletter-input:focus {
          outline: none;
          border-color: var(--blue-500);
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
        }

        .newsletter-button {
          padding: 0.875rem 1.75rem;
          background: var(--black);
          color: var(--white);
          border: none;
          border-radius: var(--radius);
          font-weight: 600;
          font-size: 1rem;
          cursor: pointer;
          transition: all var(--transition-fast);
          position: relative;
          overflow: hidden;
        }

        .newsletter-button:hover {
          transform: translateY(-1px);
          box-shadow: var(--shadow-md);
        }

        .newsletter-button:disabled {
          background: var(--green-600);
          cursor: default;
        }

        .footer-grid {
          display: grid;
          grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
          gap: 4rem;
          margin-bottom: 3rem;
        }

        .footer-brand h3 {
          font-size: 1.5rem;
          font-weight: 800;
          color: var(--black);
          margin-bottom: 1rem;
        }

        .footer-brand p {
          color: var(--gray-600);
          line-height: 1.6;
          margin-bottom: 2rem;
          max-width: 350px;
        }

        .footer-section h4 {
          font-size: 0.875rem;
          font-weight: 700;
          color: var(--gray-900);
          margin-bottom: 1.5rem;
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }

        .footer-links {
          list-style: none;
        }

        .footer-links li {
          margin-bottom: 0.75rem;
        }

        .footer-link {
          color: var(--gray-600);
          text-decoration: none;
          font-weight: 500;
          font-size: 0.95rem;
          transition: all var(--transition-fast);
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
        }

        .footer-link:hover {
          color: var(--gray-900);
          transform: translateX(2px);
        }

        .footer-link-new {
          display: inline-flex;
          padding: 0.125rem 0.5rem;
          background: var(--blue-100);
          color: var(--blue-600);
          border-radius: 50px;
          font-size: 0.625rem;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }

        .footer-social {
          display: flex;
          gap: 1rem;
          margin-top: 1.5rem;
        }

        .social-link {
          width: 44px;
          height: 44px;
          background: var(--gray-100);
          border-radius: var(--radius);
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--gray-600);
          transition: all var(--transition-fast);
        }

        .social-link:hover {
          background: var(--blue-600);
          color: var(--white);
          transform: translateY(-2px);
        }

        .social-link svg {
          width: 20px;
          height: 20px;
        }

        .footer-bottom {
          border-top: 1px solid var(--gray-200);
          padding-top: 2rem;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          color: var(--gray-500);
          font-size: 0.875rem;
          flex-wrap: wrap;
          gap: 2rem;
        }

        .footer-bottom-left p {
          margin-bottom: 0.5rem;
        }

        .footer-bottom-right {
          display: flex;
          gap: 2rem;
          flex-wrap: wrap;
        }

        .footer-bottom-right .footer-link {
          font-size: 0.875rem;
          color: var(--gray-500);
        }

        .footer-bottom-right .footer-link:hover {
          color: var(--blue-600);
        }

        @media (max-width: 1024px) {
          .footer-grid {
            grid-template-columns: 1fr 1fr 1fr;
            gap: 3rem;
          }

          .footer-brand {
            grid-column: 1 / -1;
          }
        }

        @media (max-width: 768px) {
          .footer {
            padding: 4rem 1rem 2rem;
          }

          .footer-newsletter {
            padding: 2rem;
          }

          .newsletter-form {
            flex-direction: column;
          }

          .footer-grid {
            grid-template-columns: 1fr 1fr;
            gap: 2rem;
          }

          .footer-bottom {
            flex-direction: column;
            gap: 1rem;
          }
        }

        @media (max-width: 640px) {
          .footer-grid {
            grid-template-columns: 1fr;
            gap: 2rem;
          }

          .newsletter-title {
            font-size: 1.5rem;
          }
        }
      `}</style>

      <footer className="footer">
        <div className="footer-container">
          <div className="footer-newsletter">
            <h3 className="newsletter-title">Stay at the Frontier</h3>
            <p className="newsletter-subtitle">
              Get exclusive insights into electromagnetic computing breakthroughs
            </p>
            <form className="newsletter-form" onSubmit={handleSubscribe}>
              <input
                type="email"
                className="newsletter-input"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button 
                type="submit" 
                className="newsletter-button"
                disabled={subscribed}
              >
                {subscribed ? '✓ Subscribed' : 'Subscribe'}
              </button>
            </form>
          </div>

          <div className="footer-grid">
            <div className="footer-brand">
              <h3>angalifu</h3>
              <p>
                Pioneering the transition from digital computation to continuous electromagnetic field processing. 
                Where sensation becomes solution, and attention becomes architecture.
              </p>
              <div className="footer-social">
                <a href="https://github.com" className="social-link" aria-label="GitHub">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                  </svg>
                </a>
                <a href="https://twitter.com" className="social-link" aria-label="Twitter">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                  </svg>
                </a>
                <a href="https://linkedin.com" className="social-link" aria-label="LinkedIn">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                </a>
                <a href="https://youtube.com" className="social-link" aria-label="YouTube">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                  </svg>
                </a>
              </div>
            </div>

            <div className="footer-section">
              <h4>Research</h4>
              <ul className="footer-links">
                <li><Link to="/research" className="footer-link">Publications</Link></li>
                <li><Link to="/research/papers" className="footer-link">White Papers</Link></li>
                <li><Link to="/research/patents" className="footer-link">Patents</Link></li>
                <li><Link to="/research/collaborations" className="footer-link">Collaborations</Link></li>
                <li>
                  <Link to="/research/quantum" className="footer-link">
                    Quantum Research
                    <span className="footer-link-new">New</span>
                  </Link>
                </li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Technology</h4>
              <ul className="footer-links">
                <li><Link to="/technology/eadc" className="footer-link">EADC Platform</Link></li>
                <li><Link to="/technology/lightfold" className="footer-link">LightFold Engine</Link></li>
                <li><Link to="/technology/demos" className="footer-link">Live Demos</Link></li>
                <li><Link to="/technology/benchmarks" className="footer-link">Benchmarks</Link></li>
                <li><Link to="/technology/roadmap" className="footer-link">Roadmap</Link></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Developers</h4>
              <ul className="footer-links">
                <li><Link to="/developers/docs" className="footer-link">Documentation</Link></li>
                <li><Link to="/developers/api" className="footer-link">API Reference</Link></li>
                <li><Link to="/developers/sdk" className="footer-link">SDK Downloads</Link></li>
                <li><Link to="/developers/tutorials" className="footer-link">Tutorials</Link></li>
                <li><Link to="/developers/community" className="footer-link">Community</Link></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Company</h4>
              <ul className="footer-links">
                <li><Link to="/about" className="footer-link">About Us</Link></li>
                <li><Link to="/team" className="footer-link">Leadership</Link></li>
                <li><Link to="/careers" className="footer-link">Careers</Link></li>
                <li><Link to="/news" className="footer-link">News & Media</Link></li>
                <li><Link to="/contact" className="footer-link">Contact</Link></li>
              </ul>
            </div>
          </div>

          <div className="footer-bottom">
            <div className="footer-bottom-left">
              <p>&copy; 2025 angalifu consortium. all rights reserved.</p>
              <p>computational sovereignty through electromagnetic transcendence.</p>
            </div>
            <div className="footer-bottom-right">
              <Link to="/privacy" className="footer-link">Privacy Policy</Link>
              <Link to="/terms" className="footer-link">Terms of Service</Link>
              <Link to="/security" className="footer-link">Security</Link>
              <Link to="/accessibility" className="footer-link">Accessibility</Link>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
